import { render } from "./FeedList.vue?vue&type=template&id=5570b27c&scoped=true"
import script from "./FeedList.vue?vue&type=script&lang=js"
export * from "./FeedList.vue?vue&type=script&lang=js"

import "./FeedList.vue?vue&type=style&index=0&id=5570b27c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5570b27c"]])

export default __exports__